import React, { Component } from 'react';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { isPristine } from 'redux-form';
import {
  casePartSelect,
  clearSnapshots,
  forceFormRefresh,
  getSnapshots,
  refreshSeadragon,
  setCadessOverlay,
  specimenSelect,
  saveAnalysisClientOnly,
  saveCaseLevelAnalysisClientOnly,
  showConfirmModal,
} from '../../redux/actions';
import { CASE_PART_ONE, CASE_PART_TWO, userRoles, MODAL_CONFIRM_DISCARD_CHANGES, caseStatus } from '../../constants';
import { buildCaseFormId, buildSpecimenFormId } from '../../helpers/formIdCreator';

class CaseMenuTabs extends Component {
  tabs = {
    clinical_tab: 'clinical_tab',
    caselevel_tab: 'caselevel_tab',
    specimen_tab: 'specimen_tab',//later a number will be added for each specimen tab
  }

  state = { value: this.tabs.clinical_tab };


  componentDidUpdate(prevProps) {
    const { selectedCase } = this.props;
    // if another case is selected, reset selected tab 
    // (ignore the warnings about wrong value in <Tabs>)
    if (selectedCase._id !== prevProps.selectedCase._id) {
      this.setState({ value: this.tabs.clinical_tab });
    }
  }


  loadClinicalInformationLevel = () => {
    const { casePartSelect, forceFormRefresh } = this.props;
    casePartSelect(CASE_PART_ONE);
    forceFormRefresh();
  };

  loadCaseLevel = () => {
    const {
      casePartSelect,
      clearSnapshots,
      forceFormRefresh,
    } = this.props;

    clearSnapshots();
    casePartSelect(CASE_PART_TWO);
    forceFormRefresh();
  };

  loadSpecimenLevel = (specimen) => {
    const {
      casePartSelect,
      refreshSeadragon,
      specimenSelect,
      forceFormRefresh,
      setCadessOverlay,
    } = this.props;

    setCadessOverlay(true);
    refreshSeadragon();
    casePartSelect(CASE_PART_TWO);
    specimenSelect(specimen);
    forceFormRefresh();
  };


  handleChange = (event, value) => {
    const { pristine, showConfirmModal } = this.props;

    const goToClickedTab = () => {
      if (value.startsWith('specimen_tab')) {
        const { specimens } = this.props;
        const specimenId = value.replace('specimen_tab', '');
        const clickedTabSpecimen = specimens.find(s => s.id === specimenId);
        this.loadSpecimenLevel(clickedTabSpecimen);
      } else if (value === this.tabs.clinical_tab) {
        this.loadClinicalInformationLevel();
      } else if (value === this.tabs.caselevel_tab) {
        this.loadCaseLevel();
      }
      this.setState({ value });
    }

    if (!pristine) {
      showConfirmModal(MODAL_CONFIRM_DISCARD_CHANGES, { onConfirm: goToClickedTab });
    } else {
      goToClickedTab();
    }

  };


  renderSpecimenTabs = () => {
    const { specimens, currentPathologist, unsavedAnalyzes, selectedSpecimen } = this.props;
    return (
      specimens.map((specimen, index) => {
        const hasUnsavedChanges = unsavedAnalyzes
          .some(a => a.formId === buildSpecimenFormId(specimen, currentPathologist));

        let toolTipText = hasUnsavedChanges ? '* Has Unsaved Changes' : '';
        let isInvalid = false;
        try {
          isInvalid = specimen.analyses.find(a => (a.assignee === currentPathologist._id)).isValid === false;
          if (isInvalid) {
            if (toolTipText !== '') toolTipText += '\n';
            toolTipText += '* Latest Saved Form Is Invalid';
          }
        } catch (e) { }

        if (specimen.imgUrl.length && specimen._id) {
          return (
            <Tab
              title={toolTipText}
              value={this.tabs.specimen_tab + specimen.id}
              key={specimen._id}
              selected={selectedSpecimen.id === specimen.id}
              label={`Specimen ${index + 1}`}
              className={`
                   ${selectedSpecimen.id === specimen.id ? 'backgroundColorWhite' : 'backgroundColorGrey'}${' '}
                   ${selectedSpecimen.id === specimen.id ? 'borderColorWhite' : 'borderColorGrey'}${' '}
                   ${hasUnsavedChanges && 'hasUnsavedChanges'}${' '}
                   ${isInvalid && 'hasInvalidValues'}${' '}                   
                   tabStyle tabStyleSmall tabStyleCaseLevel tab
                 `}
            />
          );
        }
        return false;
      }));
  };

  renderCaseTab = () => {
    const { unsavedAnalyzes, selectedCase, currentPathologist, casePartSelected, selectedSpecimen } = this.props;
    const caseLevelActive = casePartSelected === CASE_PART_TWO && !selectedSpecimen.id;

    const hasUnsavedChanges = unsavedAnalyzes
      .some(a => a.formId === buildCaseFormId(selectedCase, currentPathologist));

    let toolTipText = hasUnsavedChanges ? '* Has Unsaved Changes' : '';
    let isInvalid = false;
    try {
      isInvalid = selectedCase.analyses.find(a => (a.assignee === currentPathologist._id)).isValid === false;
      if (isInvalid) {
        if (toolTipText !== '') toolTipText += '\n';
        toolTipText += '* Latest Saved Form Is Invalid';
      }
    } catch (e) { }

    return (
      <Tab
        title={toolTipText}
        value={this.tabs.caselevel_tab}
        selected={caseLevelActive}
        label="Case Level"
        classes={{
          root: `
            ${caseLevelActive ? 'backgroundColorWhite' : 'backgroundColorGrey'}${' '}
            ${caseLevelActive ? 'borderColorWhite' : 'borderColorGrey'}${' '}
            ${hasUnsavedChanges && 'hasUnsavedChanges'}${' '}
            ${isInvalid && 'hasInvalidValues'}${' '}
            tabStyle tabStyleCaseLevel tab tabStyleSmall'
          `,
        }}
      />
    );
  };

  renderClinicalInformationTab = () => (
    <Tab
      value={this.tabs.clinical_tab}
      label="Clinical information"
    />
  );


  render() {
    const {
      selectedCase,
      specimens,
      analyseesTabsShouldBeVisible,
      userIsPathologist,
    } = this.props;
    const { value } = this.state;

    specimens.sort((a, b) => (Number(a.id) < Number(b.id) ? -1 : 1));
    const showCaseTab = specimens.some(specimen => specimen.imgUrl.length && specimen._id);

    return (
      <div className="tabItemContainer">
        <Tabs
          value={value}
          onChange={this.handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {this.renderClinicalInformationTab()}

          {(analyseesTabsShouldBeVisible && !userIsPathologist && showCaseTab) && this.renderCaseTab()}
          {analyseesTabsShouldBeVisible && this.renderSpecimenTabs()}
          {(analyseesTabsShouldBeVisible && userIsPathologist && showCaseTab) && this.renderCaseTab()}
        </Tabs>
        {selectedCase.specimens.length <= 0 && <ReactTooltip event="click" place="right" effect="solid" type="error" />}
      </div>
    );

  }
};


const mapStateToProps = (
  {
    _case: {
      currentPathologist,
      selectedCase,
      casePartSelected,
      specimens,
      selectedSpecimen,
      unsavedAnalyzes,
    },
    auth: { user: { role } },
  },
) => {
  // only when admin leavs cliical form with unsaved changes this is used.
  // const pristine = isPristine('caseSpecimenForm')(state) && isPristine('caseGeneralInformation')(state);
  const pristine = true;
  const { workFlowStatusDemo: { ANALYSIS_SUBMITTED, AWAITING_ANALYSIS } } = caseStatus;
  const userRole = role;
  const currentStatus = selectedCase.status.workFlowStatusDemo;
  const userIsSurgeon = userRole === userRoles.surgeon;
  const userIsPathologist = userRole === userRoles.pathologist;
  const userIsAdmin = userRole === userRoles.admin;
  const userIsTechnician = (userRole === userRoles.technician || userRole === userRoles.val_technician);
  const analyseesTabsShouldBeVisible = ((currentStatus === ANALYSIS_SUBMITTED && userIsSurgeon)
    || ((currentStatus === AWAITING_ANALYSIS || currentStatus === ANALYSIS_SUBMITTED) && userIsPathologist)
    || userIsAdmin)
    && !userIsTechnician;
  return {
    currentPathologist,
    selectedCase,
    casePartSelected,
    specimens,
    selectedSpecimen,
    pristine,
    unsavedAnalyzes,
    analyseesTabsShouldBeVisible,
    userIsPathologist,
  };
};


export default connect(
  mapStateToProps,
  {
    casePartSelect,
    refreshSeadragon,
    specimenSelect,
    getSnapshots,
    clearSnapshots,
    forceFormRefresh,
    setCadessOverlay,
    saveAnalysisClientOnly,
    saveCaseLevelAnalysisClientOnly,
    showConfirmModal,
  },
)(CaseMenuTabs);
